import { render, staticRenderFns } from "./EventFormView.vue?vue&type=template&id=0cc7da8e&"
import script from "./EventFormView.vue?vue&type=script&lang=js&"
export * from "./EventFormView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports